import * as actions from 'actions';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {

    case actions.CHAT_MESSAGES_UPDATE: {
      if(action.initiatedByServer) {
        return INITIAL_STATE;
      }

      return [
        ...state,
        ...action.result.chatMessagesIds
      ];
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatItems/chatMessagesBuffer/reducer.js
 **/